// ============================================
// services/draft.ts
//
// sessionStorage 中保存 Studio 分享过来的草稿数据.
// /from-app 路由兑换成功后写入, /publish 路由读取并预填表单.
//
// 用 sessionStorage 是为了:
//   - 浏览器关闭 tab 自动清理 (敏感数据不长期残留)
//   - 比 URL 参数安全, 不进浏览器历史
// ============================================

import type { SharedDraft } from '../types/community';

const KEY = 'HIPIIDO_COMMUNITY_DRAFT';

export function saveDraft(draft: SharedDraft): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(draft));
  } catch (e) {
    console.error('[draft] save failed:', e);
  }
}

export function loadDraft(): SharedDraft | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw) as SharedDraft;
  } catch {
    return null;
  }
}

export function clearDraft(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
